import React from 'react'
import Typography from '../../design-system/foundations/typography/Typography'

const DisplayPriceUiDefault = (props) => {
    return (
        <React.Fragment>
            {/************************* PINTAMOS PRECIOS **********************************/}
            {props.hasDiscount ? (
                <React.Fragment>
                    {props.showOldPrice && (
                        <Typography block typeface="body-xs-regular" {...(props.white ? { white: true } : { ['neutral-600']: true} )}>
                            <del>
                                {props.price}&nbsp;
                                {props.priceFormat}
                            </del>
                        </Typography>
                    )}
                    <Typography block typeface="body-m-regular" {...(props.white && { white: true })}>
                        {props.discountPrice}&nbsp;{props.discountFormat}
                    </Typography>
                </React.Fragment>
            ) : (
                <Typography block typeface="body-m-regular" {...(props.white && { white: true })}>
                    {props.price}&nbsp;{props.priceFormat}
                </Typography>
            )}
            {/********************************************************************************/}
        </React.Fragment>
    )
}

export default DisplayPriceUiDefault